module.exports = __webpack_public_path__ + "media/images/sp/stores/namba/main-visual-5b4e1cec055d679b0b89f6f6c49e3311.jpg";